import { Dispatch, SetStateAction, useState } from 'react'

/**
 * A useState that remembers the value that is passed into it.
 * If a different value is passed, the state updates to that new value.
 *
 * Use it if you need local state that changes when the parent state changes (usually from an API response).
 */
export const useLatestState = <T>(latestValue: T): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState(latestValue)
  const [lastValue, setLastValue] = useState(latestValue)

  if (lastValue !== latestValue) {
    setLastValue(latestValue)
    setValue(latestValue)
  }

  return [value, setValue]
}
